/** MCP + external-API-surface product events (spec 68 §6.6.3). */
import { z } from 'zod';
import { DEFAULT_SCHEMA_VER, id } from './_shared.js';

export const mcpEvents = {
  'mcp.client_registered': {
    schema: z.object({
      client_id: id,
      registration_kind: z.enum(['dcr', 'cimd']),
      domain: z.string().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'mcp.consent_granted': {
    schema: z.object({ account_id: id, client_id: id, scopes: z.array(z.string()).optional() }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'mcp.consent_denied': {
    schema: z.object({ account_id: id, client_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'mcp.tool_called': {
    schema: z.object({
      account_id: id,
      client_id: id,
      tool_slug: z.string().min(1),
      outcome: z.string().min(1),
      duration_ms: z.number().nonnegative().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'mcp.session_started': {
    schema: z.object({
      account_id: id,
      client_id: id,
      transport: z.enum(['streamable_http', 'sse']),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
} as const;
